import type { MarketDataDto } from "../../../shared/types/MarketDataDto";
import { AssetType } from "../../../shared/types/AssetType";
import dayjs from "dayjs";

class ChartDataSourceService {
    getData = (
        marketDataDto: MarketDataDto | undefined,
        selectedExpiration: string,
        selectedOptionType: AssetType,
        intermediateStrikeStep: number,
    ): number[][] => {
        const data: number[][] = [];
        
        if (!marketDataDto)
        {
            data.push([]);
            data.push([]);
            return data;
        }
        
        const strikes: number[] = [];
        const impliedVolatilityValues: number[] = [];
        
        let index = -1;
        
        marketDataDto
            .OptionInfos
            .filter(x => dayjs(selectedExpiration).isSame(dayjs(x.ExpireAt), 'day') && x.Type == selectedOptionType)
            .sort((x, y) => x.Strike > y.Strike ? 1 : -1)
            .map(x => {
                const currentStrike = x.Strike;
                const currentImpliedVolatility = x.MarkImpliedVolatility * 100;
                
                // Add intermediate values
                if (index >= 0 && intermediateStrikeStep < (currentStrike - strikes[index])) {
                    let previousStrike = strikes[index];
                    let previousImpliedVolatility = impliedVolatilityValues[index];

                    const interImpliedVolatilityStep =
                        (currentImpliedVolatility - previousImpliedVolatility) /
                        ((currentStrike - previousStrike) / intermediateStrikeStep);

                    previousStrike += intermediateStrikeStep;
                    previousImpliedVolatility += interImpliedVolatilityStep;
                    
                    while (previousStrike < currentStrike) {
                        strikes.push(previousStrike);
                        impliedVolatilityValues.push(previousImpliedVolatility)

                        previousStrike += intermediateStrikeStep;
                        previousImpliedVolatility += interImpliedVolatilityStep;
                        index++;
                    }
                }

                strikes.push(x.Strike);
                impliedVolatilityValues.push(x.MarkImpliedVolatility * 100);
                index++;
            });      
        
        data.push(strikes);
        data.push(impliedVolatilityValues);
        
        return data;
    }
}

export const chartDataSourceService = new ChartDataSourceService();